export const createUserDeviceGroups = /* GraphQL */ `
  mutation CreateUserDeviceGroups(
    $input: CreateUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    createUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group2 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group3 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group4 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group5 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserDeviceGroups = /* GraphQL */ `
  mutation UpdateUserDeviceGroups(
    $input: UpdateUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    updateUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group2 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group3 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group4 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      group5 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserDeviceGroups = /* GraphQL */ `
  mutation DeleteUserDeviceGroups(
    $input: DeleteUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    deleteUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group2 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group3 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group4 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group5 {
        name
        devices {
            id
            directions
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;